import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Swal from "sweetalert2";
import NewsModel from '../../models/NewsModel';
import UserBankAcountModel from '../../models/UserBankAcountModel';
import UserModel from '../../models/UserModel';
import ComboModel from '../../models/ComboModel';
import { RiVipCrown2Fill } from 'react-icons/ri';

const validationSchema = Yup.object().shape({
    name: Yup.string().required('Không được để trống!'),
    email: Yup.string().required('Không được để trống!').email('Email phải đúng định dạng!'),
    user_name: Yup.string().required('Không được để trống!').matches(/^\S*$/, 'Không được chứa khoảng trắng!'),
    account_balance: Yup.string().required('Không được để trống!').matches(/^[0-9]+$/, 'Chỉ nhập số!'),
    password: Yup.string()
        .min(6, 'Độ dài tối thiểu 6 ký tự')
        .max(32, 'Độ dài tối đa 32 ký tự')
});

function ModalDetailUser(props) {
    const [initialValues, setInitialValues] = useState({
        user_id: '',
        name: '',
        email: '',
        user_name: '',
        account_balance: '',
        password_admin_reset: '',
        password: '',
        combo_slots: 0,
        combo_current: '',
        combo_days: 60,
    });

    useEffect(() => {
        if (props.user) {
            const rawDays = props.user.combo_days !== undefined && props.user.combo_days !== null && Number(props.user.combo_days) > 0
                ? Number(props.user.combo_days)
                : ((Number(props.user.combo_slots || 0)) * 30);
            const calculatedSlots = Math.floor(rawDays / 30);

            setInitialValues({
                user_id: props.user.id,
                name: props.user.name,
                email: props.user.email,
                user_name: props.user.user_name,
                account_balance: props.user.account_balance,
                password_admin_reset: props.user.password_admin_reset,
                password: '',
                combo_slots: calculatedSlots,
                combo_current: props.user.combo_current || '',
                combo_days: rawDays,
            });
        }
    }, [props.user]);

    const onSubmit = async (values) => {
        try {
            await UserModel.adminUpdate({
                ...values,
                combo_slots: Number(values.combo_slots || 0),
                combo_days: Number(values.combo_days || 0)
            });
            // Cập nhật đồng bộ lượt và ngày combo
            await ComboModel.adminSetUserSlots({
                user_id: values.user_id,
                combo_slots: Number(values.combo_slots || 0),
                combo_days: Number(values.combo_days || 0),
                combo_current: values.combo_current || 'COMBO_CUSTOM'
            });

            // Notification
            Swal.fire({
                icon: "success",
                title: "Cập nhật tài khoản và gói Combo thành công!",
                showConfirmButton: false,
                timer: 2000,
            });
            setTimeout(() => {
                reloadPage();
            }, 1500);
        } catch (err) {
            Swal.fire({
                icon: "error",
                title: "Cập nhật thất bại!",
                showConfirmButton: false,
                timer: 2000,
            });
        }
    };

    const reloadPage = () => {
        window.location.reload();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Cập nhật Tài khoản
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={initialValues}
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {({ errors, touched, values, setFieldValue }) => (
                        <Form>
                            <div className='row'>
                                <div className='col-6'>
                                    <div className='pt-2'>
                                        <label htmlFor="name" className='text-warning'>Tên:</label>
                                        <Field className="form-control" type="text" id="name" name="name" />
                                        {errors.name && touched.name ? (
                                            <div style={{ color: 'red' }}>{errors.name}</div>
                                        ) : null}
                                    </div>
                                    <div className='pt-2'>
                                        <label htmlFor="email" className='text-warning'>Email:</label>
                                        <Field className="form-control" type="text" id="email" name="email" />
                                        {errors.email && touched.email ? (
                                            <div style={{ color: 'red' }}>{errors.email}</div>
                                        ) : null}
                                    </div>
                                    <div className='pt-2'>
                                        <label htmlFor="user_name" className='text-warning'>Tài khoản(User_name):</label>
                                        <Field className="form-control" type="text" id="user_name" name="user_name" />
                                        {errors.user_name && touched.user_name ? (
                                            <div style={{ color: 'red' }}>{errors.user_name}</div>
                                        ) : null}
                                    </div>
                                    <div className='pt-2'>
                                        <label htmlFor="account_balance" className='text-warning'>Số dư:</label>
                                        <Field className="form-control" type="text" id="account_balance" name="account_balance" />
                                        {errors.account_balance && touched.account_balance ? (
                                            <div style={{ color: 'red' }}>{errors.account_balance}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='pt-2'>
                                        <label htmlFor="password_admin_reset" className='text-warning'>Mật Khẩu hiện tại:</label>
                                        <Field className="form-control" type="text" id="password_admin_reset" name="password_admin_reset" readOnly/>
                                        {errors.password_admin_reset && touched.password_admin_reset ? (
                                            <div style={{ color: 'red' }}>{errors.password_admin_reset}</div>
                                        ) : null}
                                    </div>
                                    <div className='pt-2'>
                                        <label htmlFor="password" className='text-warning'>Đặt lại mật khẩu:</label>
                                        <Field className="form-control" type="text" id="password" name="password" />
                                        {errors.password && touched.password ? (
                                            <div style={{ color: 'red' }}>{errors.password}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>

                            {/* Cấu hình gói Combo VIP */}
                            <div className="row mt-3 pt-3 border-top border-secondary border-opacity-25" style={{ background: 'rgba(245, 158, 11, 0.05)', borderRadius: '8px', padding: '12px' }}>
                                <div className="col-12 mb-2 d-flex align-items-center justify-content-between flex-wrap gap-2">
                                    <div className="d-flex align-items-center gap-2">
                                        <RiVipCrown2Fill color="#f59e0b" size={18} />
                                        <span style={{ color: '#fbbf24', fontWeight: '700', fontSize: '13.5px' }}>ĐẶC QUYỀN GÓI COMBO VIP CHO TÀI KHOẢN</span>
                                    </div>
                                    <div className="text-warning small" style={{ fontWeight: 600 }}>
                                        Tổng quỹ: {values.combo_days || 0} ngày (~ {Math.floor((values.combo_days || 0) / 30)} lượt)
                                    </div>
                                </div>
                                
                                <div className="col-md-6 pt-2">
                                    <label htmlFor="combo_slots" className="text-warning small">
                                        Số lượt VIP (1 lượt = 30 ngày):
                                    </label>
                                    <input 
                                        className="form-control" 
                                        type="number" 
                                        id="combo_slots" 
                                        name="combo_slots" 
                                        min="0"
                                        value={values.combo_slots || 0}
                                        onChange={(e) => {
                                            const s = Math.max(0, parseInt(e.target.value, 10) || 0);
                                            const remainder = Number(values.combo_days || 0) % 30;
                                            setFieldValue('combo_slots', s);
                                            setFieldValue('combo_days', (s * 30) + remainder);
                                        }} 
                                    />
                                    {/* Nút cộng lượt nhanh */}
                                    <div className="d-flex gap-1 mt-1 flex-wrap">
                                        <button type="button" className="btn btn-xs btn-outline-warning" onClick={() => {
                                            const newDays = Number(values.combo_days || 0) + 30;
                                            setFieldValue('combo_days', newDays);
                                            setFieldValue('combo_slots', Math.floor(newDays / 30));
                                        }}>+1 Lượt</button>
                                        <button type="button" className="btn btn-xs btn-outline-warning" onClick={() => {
                                            const newDays = Number(values.combo_days || 0) + 150;
                                            setFieldValue('combo_days', newDays);
                                            setFieldValue('combo_slots', Math.floor(newDays / 30));
                                        }}>+5 Lượt</button>
                                        <button type="button" className="btn btn-xs btn-outline-warning" onClick={() => {
                                            const newDays = Number(values.combo_days || 0) + 300;
                                            setFieldValue('combo_days', newDays);
                                            setFieldValue('combo_slots', Math.floor(newDays / 30));
                                        }}>+10 Lượt</button>
                                    </div>
                                </div>

                                <div className="col-md-6 pt-2">
                                    <label htmlFor="combo_days" className="text-warning small">
                                        Số ngày VIP lẻ (quỹ ngày):
                                    </label>
                                    <input 
                                        className="form-control" 
                                        type="number" 
                                        id="combo_days" 
                                        name="combo_days" 
                                        min="0"
                                        value={values.combo_days || 0}
                                        onChange={(e) => {
                                            const d = Math.max(0, parseInt(e.target.value, 10) || 0);
                                            setFieldValue('combo_days', d);
                                            setFieldValue('combo_slots', Math.floor(d / 30));
                                        }} 
                                    />
                                    {/* Nút cộng ngày nhanh */}
                                    <div className="d-flex gap-1 mt-1 flex-wrap">
                                        <button type="button" className="btn btn-xs btn-outline-info" onClick={() => {
                                            const newDays = Number(values.combo_days || 0) + 1;
                                            setFieldValue('combo_days', newDays);
                                            setFieldValue('combo_slots', Math.floor(newDays / 30));
                                        }}>+1 Ngày</button>
                                        <button type="button" className="btn btn-xs btn-outline-info" onClick={() => {
                                            const newDays = Number(values.combo_days || 0) + 7;
                                            setFieldValue('combo_days', newDays);
                                            setFieldValue('combo_slots', Math.floor(newDays / 30));
                                        }}>+7 Ngày</button>
                                        <button type="button" className="btn btn-xs btn-outline-info" onClick={() => {
                                            const newDays = Number(values.combo_days || 0) + 30;
                                            setFieldValue('combo_days', newDays);
                                            setFieldValue('combo_slots', Math.floor(newDays / 30));
                                        }}>+30 Ngày</button>
                                    </div>
                                </div>

                                <div className="col-12 pt-2">
                                    <label htmlFor="combo_current" className="text-warning small">Gói Combo hiển thị:</label>
                                    <Field as="select" className="form-control" id="combo_current" name="combo_current">
                                        <option value="">-- Tùy chỉnh (COMBO_CUSTOM) --</option>
                                        <option value="COMBO_5">Combo 1 (5 lượt - 7.500.000đ)</option>
                                        <option value="COMBO_10">Combo 2 (10+1 lượt - 10.000.000đ)</option>
                                        <option value="COMBO_20">Combo 3 (20+2 lượt - 14.000.000đ)</option>
                                        <option value="COMBO_50">Combo 4 (50+5 lượt - 25.000.000đ)</option>
                                    </Field>
                                </div>
                                <div className="col-12 mt-2" style={{ color: '#22c55e', fontSize: '12.5px', fontWeight: '600' }}>
                                    ♾️ Số lượt &amp; số ngày của User được bảo lưu VĨNH VIỄN trọn đời (không bao giờ hết hạn).
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={props.onHide}>
                                    Close
                                </button>
                                <button type="submit" className="btn btn-success">
                                    Xác nhận
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
}

export default ModalDetailUser;